import { useEffect, useRef, useState } from 'react';

export function UnlockSheet({
  open, onClose, onUnlock
}: {
  open: boolean;
  onClose: () => void;
  onUnlock: (password: string) => Promise<void>;
}) {
  const [pwd, setPwd] = useState('');
  const [err, setErr] = useState<string>('');
  const ref = useRef<HTMLInputElement>(null);

  useEffect(() => {
    setErr(''); setPwd('');
    if (open) setTimeout(() => ref.current?.focus(), 0);
  }, [open]);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setErr('');
    if (pwd.trim().length < 4) { setErr('Password must be at least 4 characters.'); return; }
    try {
      await onUnlock(pwd);
    } catch {
      setErr('Invalid password.');
      return;
    }
    onClose();
  }

  if (!open) return null;
  return (
    <div className="sheet" role="dialog" aria-modal="true" aria-labelledby="unlock-title">
      <div className="backdrop" onClick={onClose} aria-hidden="true"></div>
      <form className="panel glass" onSubmit={submit}>
        <h3 id="unlock-title">Unlock editing</h3>
        <p className="help">Enter your password to edit and add events.</p>
        <div className="field" style={{ marginTop: 10 }}>
          <label htmlFor="unlock-password">Password</label>
          <input id="unlock-password" ref={ref} type="password" placeholder="••••" required minLength={4}
                 value={pwd} onChange={(e)=>setPwd(e.target.value)} />
          <div className="error" aria-live="polite">{err}</div>
        </div>
        <div className="actions" style={{ marginTop: 8 }}>
          <button type="button" className="btn" onClick={onClose}>Cancel</button>
          <button className="btn primary">Unlock</button>
        </div>
      </form>
    </div>
  );
}
